
import { ICaseStoreService } from "@/services/case/ICaseStoreService";
import { Container } from "inversify";
import { IoCTypes } from "./IoCTypes";
import { CaseStoreService } from "@/services/case/CaseStoreService"

export function bindCaseStoreService(container: Container) {
    container.bind<ICaseStoreService>(IoCTypes.CaseService).to(CaseStoreService)
}